"use client";
import { jsx as e, jsxs as o, Fragment as y } from "react/jsx-runtime";
import { forwardRef as N, createElement as $ } from "react";
import i from "../../elements/ListItem/ListItem.js";
import { withCmsDataHandling as L } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import b from "../../layout/Container/Container.js";
import k from "../../layout/Section/Section.js";
import { Grid as s, rem as l, Box as G, Carousel as H, Group as S, TextLink as j, sharedHandler as F } from "@ingeniorforeningen/figurine-core";
import { listDeliveryApiParser as P } from "./List.helpers.js";
import '../../../assets/List.css';const A = "_root_4lx2u_2", D = "_gridContainer_4lx2u_7", R = "_carouselItem_4lx2u_44", m = {
  root: A,
  gridContainer: D,
  carouselItem: R
}, d = N((f, z) => {
  const {
    className: v,
    items: c,
    variant: n,
    header: x,
    moreHeader: C,
    readMore: h,
    size: u,
    ...w
  } = f, p = c[0].variant, I = u !== void 0 ? u : n === "weighted" && p === "withImage" ? 7 : n === "weighted" && p === "withoutImage" ? 6 : 5, t = c.slice(0, I), g = [...t];
  g.shift();
  const _ = (r, a) => {
    switch (a) {
      case 0:
        return /* @__PURE__ */ e(i, { ...r, size: "large" });
      case 1:
        return /* @__PURE__ */ e(i, { ...r, size: "small" });
      case 2:
        return /* @__PURE__ */ e(i, { ...r, size: "small" });
      case 3:
        return r.variant === "withImage" ? /* @__PURE__ */ e(i, { ...r, size: "small" }) : /* @__PURE__ */ e(i, { ...r, size: "medium" });
      default:
        return /* @__PURE__ */ e(i, { ...r, size: "medium" });
    }
  };
  return /* @__PURE__ */ e(b, { ref: z, ...w, className: `${m.root} ${v}`, size: "lg", children: /* @__PURE__ */ o(k, { header: t.length > 0 ? x : void 0, children: [
    t.length === 1 && /* @__PURE__ */ e(i, { ...t[0], size: "medium" }),
    t.length === 2 && /* @__PURE__ */ o(s, { container: !0, columns: `repeat(auto-fit, minmax(${l("330px")}, 1fr))`, children: [
      /* @__PURE__ */ e(s, { item: !0, children: /* @__PURE__ */ e(i, { ...t[0], size: "large" }) }),
      /* @__PURE__ */ e(s, { item: !0, children: /* @__PURE__ */ e(i, { ...t[1], size: "large" }) })
    ] }),
    t.length >= 3 && /* @__PURE__ */ o(y, { children: [
      /* @__PURE__ */ e(
        s,
        {
          container: !0,
          visibleFrom: "sm",
          mod: { variant: n },
          className: m.gridContainer,
          children: t.map((r, a) => /* @__PURE__ */ e(s, { item: !0, mod: { variant: r.variant }, children: n === "weighted" ? _(r, a) : /* @__PURE__ */ e(i, { ...r, size: "medium" }) }, `desktop${r.header}${a}`))
        }
      ),
      /* @__PURE__ */ o(G, { hiddenFrom: "sm", children: [
        /* @__PURE__ */ e(i, { ...t[0], size: "large", mb: l("40px"), display: "block" }),
        /* @__PURE__ */ e(
          H,
          {
            sectionHeader: C,
            draggable: !0,
            slideSize: l("251px"),
            withControls: !1,
            slideGap: l("12px"),
            children: g?.map((r, a) => /* @__PURE__ */ $(
              i,
              {
                ...r,
                className: m.carouselItem,
                mod: { variant: r.variant, index: a },
                size: "small",
                key: `mobile${r.header}${a}`
              }
            ))
          }
        )
      ] }),
      h && /* @__PURE__ */ e(S, { justify: "right", children: /* @__PURE__ */ e(
        j,
        {
          ...h,
          variant: "component",
          icon: "ChevronRight",
          iconPlacement: "right"
        }
      ) })
    ] })
  ] }) });
});
d.displayName = "Container";
const V = L({
  Component: F(d),
  deliveryApiParser: P
});
V.displayName = d.displayName;
export {
  m as L,
  d as _List,
  V as default
};
